// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      maintPlanTypeOptions: [
        "Area",
        "Asset",
        "Campaign",
        "Facility",
        "Package",
        "Project",
        "Section",
        "Line",
        "System",
        "Type",
        "Unit",
        "Vendor"
      ],
      // eslint-disable-next-line
      maintPlanIsolationOptions: [
        "Facility",
        "System",
        "Unit",
        "Pkg",
        "Asset"
      ],
      // eslint-disable-next-line
      maintPlanDriverOptions: [
        "Saftey",
        "Production"
      ],
      // eslint-disable-next-line
      maintPlanPrepFactorOptions: [
        "0.1",
        "0.3",
        "0.5",
        "0.7"
      ],
      // eslint-disable-next-line
      maintPlanThemeOptions: [
        "Function",
        "Check",
        "Inspect",
        "Maint.",
        "Test"
      ]
    };
  }
};
